import $ from 'jquery';
import lottie from 'lottie-web';
import { debounce, isMobile } from './../../utils';
$(function () {
  var $lottieContainer = $('.lottie-animation');
  var windowWidth = window.innerWidth;
  if (!$lottieContainer || !$lottieContainer.length) {
    return;
  }
  initLogoAnimation();
  $(window).on('resize', debounce(onResize, 200));

  ////

  function initLogoAnimation() {
    var path = isMobile() ? '../data/lottie-dmf-mmf-mobile.json' : '../data/lottie-dmf-mmf-desktop.json';
    lottie.loadAnimation({
      autoplay: false,
      container: $lottieContainer.get(0),
      loop: true,
      path: path,
      renderer: 'svg'
    });
    var waypointSpy = new Waypoint({
      element: $lottieContainer.get(0),
      handler: function handler() {
        return playLottie(waypointSpy);
      },
      offset: '40%'
    });
  }
  function onResize() {
    if (windowWidth === window.innerWidth) {
      return;
    } else {
      windowWidth = window.innerWidth;
    }
    lottie.destroy();
    initLogoAnimation();
  }
  function playLottie(waypointSpy) {
    lottie.play();
    waypointSpy.destroy();
  }
});